<template>
  <div class="station-list-spec-item">
    <v-icon class="flex-grow-0 mr-4">{{icon}}</v-icon>
    <div class="flex-grow-1">
      <slot/>
    </div>
  </div>
</template>

<style lang="scss">
.station-list-spec-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}

.station-list-spec-item + .station-list-spec-item {
  margin-top: 8px;
}
</style>

<script>
export default {
  name: 'CSpecItem',
  props: {
    icon: {
      type: String,
      required: true
    }
  }
}
</script>
